export default __webpack_public_path__ + "static/landing-experience-light-945c22a62f16670f4e30365919b3668b.png";